import Overlay from '../classes/overlay';
import features from '/features.json';

$(window).on('ready load', () => {
  const toggleSelector = '[data-action="toggle-nav"]';
  const selector = `.nav__wrapper${
    features.sidenav || features.megamenu
      ? ', .nav__backdrop[data-action="toggle-nav"]'
      : ''
  }, body${!features.sidenav ? ', .nav-toggle[data-action="toggle-nav"]' : ''}`;

  new Overlay({
    toggle: toggleSelector,
    selector: selector,
  });
  $('.nav__chevron').on('click', function () {
    $(this).toggleClass('is-open');
    $(this).next('.nav__dropdown').slideToggle(200);
  });

  // - Megamenu backdrop
  if (features.megamenu) {
    const $backdrop = $('.nav__backdrop[data-action="toggle-nav"]');
    const $megaItems = $('.nav__wrapper .nav__item--megamenu');
    let megaCloseTimeout;

    const openBackdrop = () => {
      if ($(window).width() >= 1200 && !$backdrop.hasClass('is-open')) {
        $backdrop.addClass('is-open');
      }
    };

    const closeBackdrop = () => {
      if ($(window).width() >= 1200 && !$megaItems.filter('.is-open').length) {
        $backdrop.removeClass('is-open');
      }
    };

    $megaItems.on('mouseenter focusin', function () {
      if ($(window).width() < 1200) return;
      clearTimeout(megaCloseTimeout);
      $megaItems.not(this).removeClass('is-open');
      $(this).addClass('is-open');
      openBackdrop();
    });

    $megaItems.on('mouseleave focusout', function () {
      if ($(window).width() < 1200) return;
      const item = this;
      clearTimeout(megaCloseTimeout);
      megaCloseTimeout = setTimeout(() => {
        if (!$(item).is(':hover') && !$(item).find(':focus').length) {
          $(item).removeClass('is-open');
          closeBackdrop();
        }
      }, 180);
    });
  }

  // Filter overlay
  new Overlay({
    toggle: '[data-action="toggle-filter"]',
    selector: '.s7filter, .nav__backdrop[data-action="toggle-filter"], body', // Remove .nav-toggle if side-nav
    // toggleClass: '', // Defaults to is-open
  });
});
